import React, { useState } from 'react';
import Button from '../../../ui/Button/Button';
import { showNotification } from '../../../utils/showNotification';
import { encodeUrlSearchParams, fetchWithToken } from '@round/api';
import { downloadFileFromResponse, formatToIsoDateString } from '../../../utils/utits';
import styles from './DataDownload.module.css';
import useUrlState from '../../../hooks/useUrlState';
import DatePickerSelect from '../../../ui/DataEntry/DatePicker/DatePickerSelect/DatePickerSelect';

const DataDownload = () => {
    const [urlState, setUrlState] = useUrlState<{
        date_created_start?: string;
        date_created_end?: string;
    }>();

    const [isDownloadLoading, setIsDownloadLoading] = useState(false);

    const selectedDatesCreated: [Date, Date] | null =
        urlState.date_created_start && urlState.date_created_end
            ? [new Date(urlState.date_created_start), new Date(urlState.date_created_end)]
            : null;

    const handleSetDateCreated = (dates: Date[] | null) => {
        if (!dates) {
            setUrlState({ date_created_start: undefined, date_created_end: undefined });
            return;
        }

        const [startDate, endDate] = dates;
        setUrlState({
            date_created_start: formatToIsoDateString(startDate),
            date_created_end: formatToIsoDateString(endDate),
        });
    };

    const reportParams = {
        date_created_start: urlState.date_created_start,
        date_created_end: urlState.date_created_end,
    };

    const downloadBookingsReports = async () => {
        try {
            setIsDownloadLoading(true);
            const response = await fetchWithToken(
                `/api/apex/admin/reports/bookings/${encodeUrlSearchParams(reportParams)}`
            );
            if (response.ok) {
                await downloadFileFromResponse(response);
                return;
            }

            showNotification('Could not download booking reports', 'error');
        } catch {
            showNotification('Could not download booking reports', 'error');
        } finally {
            setIsDownloadLoading(false);
        }
    };

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Bookings Report</h1>

            <div className={styles.filterWrapper}>
                <span className={styles.label}>Date Created</span>
                <DatePickerSelect
                    value={selectedDatesCreated}
                    onChange={handleSetDateCreated}
                    onClear={() => {
                        handleSetDateCreated(null);
                    }}
                    selectRange
                    className={styles.datePickerFilter}
                />
            </div>

            <Button loading={isDownloadLoading} onClick={downloadBookingsReports}>
                Download
            </Button>
        </div>
    );
};

export default DataDownload;
